"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pageRange = function (from, to) {
    var range = [];
    from = from > 0 ? from : 1;
    for (var i = from; i <= to; i++) {
        range.push(i);
    }
    return range;
};
exports.pageRange = pageRange;
/**
 * Generate entries for pagination buttons.
 * Code is adapted from Vuetify packages/vuetify/src/components/VPagination/VPagination.ts
 * -1 indicates dots or '...' entry.
 *
 * @param value
 * @param length
 * @param totalVisible Limit the number of the shown pagination buttons
 * @param maxButtons An alias for totalVisible
 */
var pageItems = function (value, length, totalVisible, maxButtons) {
    if (totalVisible === void 0) { totalVisible = 9; }
    if (maxButtons === void 0) { maxButtons = 0; }
    var maxLength = Math.min(Math.max(0, totalVisible) || length, Math.max(0, maxButtons) || length, length);
    if (length <= maxLength) {
        return pageRange(1, length);
    }
    var even = maxLength % 2 === 0 ? 1 : 0;
    var left = Math.floor(maxLength / 2);
    var right = length - left + 1 + even;
    if (value > left && value < right) {
        var start = value - left + 2;
        var end = value + left - 2 - even;
        return __spreadArrays([1, -1], pageRange(start, end), [-1, length]);
    }
    else if (value === left) {
        var end = value + left - 1 - even;
        return __spreadArrays(pageRange(1, end), [-1, length]);
    }
    else if (value === right) {
        var start = value - left + 1;
        return __spreadArrays([1, -1], pageRange(start, length));
    }
    else {
        return __spreadArrays(pageRange(1, left), [-1], pageRange(right, length));
    }
};
exports.pageItems = pageItems;
//# sourceMappingURL=PaginationUtil.js.map